module.exports = __webpack_public_path__ + "31a9f0645a1b06f7bce2fcdec6780652.svg";